import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "row header justify-between items-center q-mb-md" }
const _hoisted_2 = { class: "col-auto client-channels-title" }
const _hoisted_3 = { class: "col-auto actions" }
const _hoisted_4 = { class: "row channels" }
const _hoisted_5 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_6 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_7 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_tick_icon = _resolveComponent("tick-icon")!
  const _component_channel_card = _resolveComponent("channel-card")!
  const _component_list_header = _resolveComponent("list-header")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_entry_list = _resolveComponent("entry-list")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "title", {}, () => [
          _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Channels", -1))
        ], true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "actions", {}, () => [
          _createVNode(_component_q_btn, {
            class: "btn tertiary q-ml-md",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.channelDialog.show = true)),
            unelevated: "",
            flat: "",
            dense: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_add_icon, { left: "" }),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "Channel", -1))
            ]),
            _: 1
          }),
          (_ctx.editing)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                class: "btn secondary q-ml-md",
                onClick: _ctx.cancel,
                unelevated: "",
                flat: "",
                dense: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_close_icon, { left: "" }),
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "Cancel", -1))
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.editing)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 1,
                class: "btn primary q-ml-md",
                onClick: _ctx.save,
                unelevated: "",
                rounded: "",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_tick_icon, { left: "" }),
                  _cache[6] || (_cache[6] = _createElementVNode("span", null, "Save", -1))
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ], true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.channels?.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.channels, (channel) => {
            return (_openBlock(), _createBlock(_component_channel_card, {
              channel: channel,
              draft: !_ctx.diffState.lhs.map(c => c.sys.id).includes(channel.sys.id),
              "pending-unlink": _ctx.toUnlink.includes(channel.sys.id),
              key: channel.sys.id,
              onChannelClick: ($event: any) => (_ctx.onChannelClick(channel.sys.id)),
              onUnlink: ($event: any) => (_ctx.unlinkChannel(channel.sys.id))
            }, null, 8, ["channel", "draft", "pending-unlink", "onChannelClick", "onUnlink"]))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, "No channels linked to client"))
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.channelDialog.show,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.channelDialog.show) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"50vw","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_list_header, {
                  title: `Select channel to link to ${_ctx.client.name?.length? _ctx.client.name : 'Client' }`
                }, null, 8, ["title"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, {
              class: "scroll",
              style: {"max-height":"50vh"}
            }, {
              default: _withCtx(() => [
                (!_ctx.channelDialog.collection.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[7] || (_cache[7] = [
                      _createElementVNode("p", null, "All available channels are already linked to the client", -1)
                    ])))
                  : (_openBlock(), _createBlock(_component_entry_list, {
                      key: 1,
                      class: "column",
                      modelValue: _ctx.channelDialog.collection,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.channelDialog.collection) = $event)),
                      "content-type": "channel",
                      config: {actions:{edit:true, create: true, add: false, remote: false}},
                      "item-config": {size:'medium'},
                      request: _ctx.channelDialog.requestHandler,
                      highlight: _ctx.channelDialog.selection,
                      paginate: 50,
                      columns: [24,24,24],
                      model: _ctx.channelDialog.model,
                      onSelect: _ctx.channelDialog.select
                    }, {
                      "actions-header": _withCtx(({ actions, loader, loading, config }) => [
                        _createVNode(_component_ozn_button, {
                          class: "entry-action__btn add-channel-btn",
                          "full-width": "",
                          "loader-style": loader,
                          loading: loading,
                          onClick: _ctx.channelDialog.addChannel
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_add_icon, { alt: "add" }, null, 512), [
                              [_vShow, !loading]
                            ]),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(loading ? '...' : config.labels?.add) + " Channel", 1)
                          ]),
                          _: 2
                        }, 1032, ["loader-style", "loading", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "request", "highlight", "model", "onSelect"]))
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  class: "btn secondary",
                  unelevated: "",
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_close_icon, {
                      class: "close-icon",
                      height: "1.5rem",
                      width: "1.5rem"
                    }),
                    _cache[8] || (_cache[8] = _createTextVNode("cancel"))
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  class: "btn primary",
                  onClick: _ctx.addDialogSelection,
                  unelevated: "",
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_add_icon, {
                      class: "add-icon",
                      height: "1.5rem",
                      width: "1.5rem"
                    }),
                    _cache[9] || (_cache[9] = _createTextVNode("Add"))
                  ]),
                  _: 1
                }, 8, ["onClick"])), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}